import React from 'react';
import BasicAlert from 'Components/ComponentLibrary/Atoms/Alerts/Basic';
import { useCommentLayoutContext } from '../../../../../CommentLayoutProvider';

const EmptyThread = () => {
  const { threadCollection } = useCommentLayoutContext();

  return (
    <BasicAlert
      severity={'error'}
      title={'Unexpected Response'}
      message={`No thread returned from link: ${threadCollection.link('self').url()}`}
    />
  );
};

export default EmptyThread;
